import { DashboardCard } from "@/modern/components/dashboard-card";
import { CardTitle } from "@/modern/components/ui/card";
import { Badge } from "@/modern/components/ui/badge";
import { Separator } from "@/modern/components/ui/separator";
import { Mail } from "lucide-react";
import { EntityOwnershipProvider, useEntityOwnershipContext } from "./context/EntityOwnershipContext";
import { NotificationTypeRow } from "./components/NotificationTypeRow";

// Header Component
const Header = ({ totalAssignments }: { totalAssignments: number }) => {
  return (
    <div className="flex justify-between items-center gap-2 flex-1">
      <CardTitle className="text-base relative">
        Ownership
        {totalAssignments > 0 && (
          <Badge variant="muted" size="xs" className="absolute -right-7 -top-2">
            {totalAssignments}
          </Badge>
        )}
      </CardTitle>
    </div>
  );
};

// Main Component Content
const EntityOwnershipViewContent = () => {
  const { ownershipData, boardUsers, handleUserSelectionChange, entityName } = useEntityOwnershipContext();

  // Calculate total assignments
  const totalAssignments = ownershipData.reduce((sum, data) => sum + data.boardUserIds.length, 0);

  return (
    <DashboardCard cardContentClassName="p-4" header={<Header totalAssignments={totalAssignments} />}>
      <div className="h-full w-full">
        <div className="h-full w-full flex flex-col gap-1.5">
          {ownershipData.length === 0 ? (
            <div className="flex flex-1 items-center justify-center h-full">
              <div className="h-full w-full">
                <div className="min-h-[12rem] h-full flex flex-col items-center justify-center gap-3 rounded-2xl border border-dashed border-muted-foreground/30 bg-muted/40 p-4 text-center shadow-sm">
                  <span className="flex size-10 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
                    <Mail className="size-5" />
                  </span>
                  <div className="space-y-1">
                    <h3 className="text-sm font-semibold text-foreground">No ownership data</h3>
                    <p className="text-xs text-muted-foreground">Ownership settings are not available for this record.</p>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            ownershipData.map((data, index) => (
              <div key={data.type}>
                <NotificationTypeRow notifyType={data.type} entityName={entityName} boardUserIds={data.boardUserIds} boardUsers={boardUsers} onSelectionChange={handleUserSelectionChange} />
                {index < ownershipData.length - 1 && <Separator className="my-0" />}
              </div>
            ))
          )}
        </div>
      </div>
    </DashboardCard>
  );
};

export const EntityOwnershipView = () => {
  return (
    <EntityOwnershipProvider>
      <EntityOwnershipViewContent />
    </EntityOwnershipProvider>
  );
};